import { Button, CssBaseline, Grid, Typography } from "@material-ui/core";
import ConfettiGenerator from "confetti-js";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import type { LoginLocationState } from "../../../auth/pages/loginPage/loginPage";
import {
  successSubscriptionImg,
  successSubscriptionRibbonImg,
} from "../../../shared/consts/imgUrls";
import { useHistory } from "../../../shared/hooks/useHistory";
import { successPageStyles } from "./successPage.styles";

const subscriptionMessages = {
  new: "Now you have full access to the numerous benefits this platform provides. Detailed instructions have been sent to your email address on how to start your first assessment whenever it suits you the best.",
  renovate:
    "Now you have full access to the numerous benefits this platform provides.",
};

const successPath = "/success";

export const SuccessPage = () => {
  const classes = successPageStyles();
  const location = useLocation();
  const history = useHistory<LoginLocationState>();

  const redirectToHome = () => {
    history.push(`/`, {
      isCreatePasswordSuccess: true,
    });
  };

  useEffect(() => {
    const confettiSettings = { target: "my-canvas" };
    const confetti = new ConfettiGenerator(confettiSettings);
    confetti.render();

    return () => confetti.clear();
  }, []);

  return (
    <div className={classes.loginContent}>
      <CssBaseline />
      <canvas id="my-canvas" className={classes.confetti} />
      <div className={classes.wrapperLogin}>
        <div className={[classes.paper, classes.loginLeftContent].join(" ")}>
          <div className={classes.formWrapper}>
            <img
              className={classes.ribbonImage}
              src={successSubscriptionRibbonImg}
              alt="Fruition subscription"
            />
            <img
              className={classes.logo}
              src={successSubscriptionImg}
              alt="Fruition subscription"
            />
            <Typography align="center" component="h1" variant="h5">
              You have successfully subscribed!
            </Typography>
            <Typography className={classes.subscriptionMessage}>
              {location.pathname === successPath
                ? subscriptionMessages.new
                : subscriptionMessages.renovate}
            </Typography>
            {location.pathname === successPath && (
              <Typography className={classes.subscriptionMessage}>
                or click in this button to start right away!
              </Typography>
            )}
            <Grid container justifyContent="center">
              <Grid item lg={4} md={4} sm={5} xs={6}>
                <Button
                  color="primary"
                  fullWidth
                  variant="contained"
                  onClick={redirectToHome}
                >
                  Login
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};
